var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7048 24.3633L7.95459 17.6114L10.2041 15.3619L14.7048 19.861L23.703 10.8612L25.9541 13.1123L14.7048 24.3633Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.36364C0 4.6759 0.670453 3.05728 1.86387 1.86387C3.05728 0.670453 4.6759 0 6.36364 0H28.6364C30.3241 0 31.9427 0.670453 33.1361 1.86387C34.3295 3.05728 35 4.6759 35 6.36364V28.6364C35 30.3241 34.3295 31.9427 33.1361 33.1361C31.9427 34.3295 30.3241 35 28.6364 35H6.36364C4.6759 35 3.05728 34.3295 1.86387 33.1361C0.670453 31.9427 0 30.3241 0 28.6364V6.36364ZM6.36364 3.18182H28.6364C29.4802 3.18182 30.2895 3.51704 30.8862 4.11375C31.483 4.71046 31.8182 5.51977 31.8182 6.36364V28.6364C31.8182 29.4802 31.483 30.2895 30.8862 30.8862C30.2895 31.483 29.4802 31.8182 28.6364 31.8182H6.36364C5.51977 31.8182 4.71046 31.483 4.11375 30.8862C3.51704 30.2895 3.18182 29.4802 3.18182 28.6364V6.36364C3.18182 5.51977 3.51704 4.71046 4.11375 4.11375C4.71046 3.51704 5.51977 3.18182 6.36364 3.18182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsc);
export default __webpack_public_path__ + "static/media/VSC.ea2dabce0437fb61548a0b72e25b6706.svg";
export { ForwardRef as ReactComponent };